import { alertLabels, alertTypes } from '@/parcels/constants'

export const availableActions = {
  retry: 'retry',
  editAddressDestination: 'editAddressDestination',
  markAsResolved: 'markAsResolved',
  contactCarrier: 'contactCarrier',
  contactUser: 'contactUser',
  editCustomsInfo: 'editCustomsInfo',
}

export const availableExceptions = [
  {
    code: alertTypes.labelCreationError,
    title: alertLabels[alertTypes.labelCreationError],
    availableActions: [availableActions.retry],
  },
  {
    code: alertTypes.wrongAddress,
    title: alertLabels[alertTypes.wrongAddress],
    availableActions: [availableActions.retry, availableActions.editAddressDestination],
  },
  {
    code: alertTypes.incompleteAddress,
    title: alertLabels[alertTypes.incompleteAddress],
    availableActions: [availableActions.editAddressDestination],
  },
  {
    code: alertTypes.pickupCreationError,
    title: alertLabels[alertTypes.pickupCreationError],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier],
  },
  {
    code: alertTypes.pickupFailed,
    title: alertLabels[alertTypes.pickupFailed],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier],
  },
  {
    code: alertTypes.unableToDeliver,
    title: alertLabels[alertTypes.unableToDeliver],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.rejectedByRecipient,
    title: alertLabels[alertTypes.rejectedByRecipient],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.returnedToSender,
    title: alertLabels[alertTypes.returnedToSender],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.recipientMissing,
    title: alertLabels[alertTypes.recipientMissing],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.deliveryPostponed,
    title: alertLabels[alertTypes.deliveryPostponed],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.missingCustomsData,
    title: alertLabels[alertTypes.missingCustomsData],
    availableActions: [availableActions.editCustomsInfo],
  },
  {
    code: alertTypes.packageDestroyed,
    title: alertLabels[alertTypes.packageDestroyed],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.packageLost,
    title: alertLabels[alertTypes.packageLost],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.packageHeld,
    title: alertLabels[alertTypes.packageHeld],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.packagedNotDelivered,
    title: alertLabels[alertTypes.packagedNotDelivered],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
  {
    code: alertTypes.statusStalled,
    title: alertLabels[alertTypes.statusStalled],
    availableActions: [availableActions.markAsResolved, availableActions.contactCarrier, availableActions.contactUser],
  },
]
